import { Injectable } from '@angular/core';
import { Cacheable } from 'ngx-cacheable';
import { AdminGeneratedService } from '../services/AdminService/admin-service-generate';

@Injectable({
  providedIn: 'root'
})
export class ServiceWithCacheService {

  constructor(private adminGenerateService: AdminGeneratedService) { }

  @Cacheable({ maxAge: 14400000 })
  countries() {
    return this.adminGenerateService.countries();
  }

  @Cacheable({ maxAge: 14400000 }) //4 saat cache de kalsın
  cities(countryId) {
    return this.adminGenerateService.cities(countryId);
  }

  @Cacheable({ maxAge: 14400000 })
  citySubdivisions(cityId) {
    return this.adminGenerateService.citySubdivisions(cityId);
  }

  @Cacheable({ maxAge: 14400000 })
  services2(request?) {
    return this.adminGenerateService.services2(request);
  }

  @Cacheable({ maxAge: 14400000 })
  servicesAll(request?) {
    return this.adminGenerateService.servicesAll(request);
  }

  @Cacheable({ maxAge: 14400000 })
  parameters(req) {
    return this.adminGenerateService.parameters(req);
  }
}
